import React from 'react';
import { useTheme } from '@mui/material';

export const ClipsPauseButtonSVG = ({
  bgFill,
  pathFill,
}: {
  bgFill?: string;
  pathFill?: string;
}) => {
  const theme = useTheme();

  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill={bgFill ? bgFill : theme.accent.collinsStache} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 17.3999C20.0058 17.3999 19.2 18.2058 19.2 19.1999V28.7999C19.2 29.794 20.0058 30.5999 21 30.5999C21.9941 30.5999 22.7999 29.794 22.7999 28.7999V19.1999C22.7999 18.2058 21.9941 17.3999 21 17.3999ZM27 17.3999C26.0058 17.3999 25.1999 18.2058 25.1999 19.1999V28.7999C25.1999 29.794 26.0058 30.5999 27 30.5999C27.9941 30.5999 28.8 29.794 28.8 28.7999V19.1999C28.8 18.2058 27.9941 17.3999 27 17.3999Z"
        fill={pathFill ? pathFill : theme.palette.secondary.main}
      />
    </svg>
  );
};

export const ClipsPlayButtonSVG = ({
  bgFill,
  pathFill,
}: {
  bgFill?: string;
  pathFill?: string;
}) => {
  const theme = useTheme();

  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill={bgFill ? bgFill : theme.accent.collinsStache} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.8297 23.1808C30.3984 23.5789 30.3984 24.4211 29.8297 24.8192L22.5735 29.8986C21.9107 30.3625 21 29.8884 21 29.0793V18.9207C21 18.1116 21.9107 17.6375 22.5735 18.1014L29.8297 23.1808Z"
        fill={pathFill ? pathFill : theme.palette.secondary.main}
      />
    </svg>
  );
};

export const ClipsPlayButtonDisabledSVG = () => {
  const theme = useTheme();

  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill={theme.palette.secondary.light} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.8297 23.1808C30.3984 23.5789 30.3984 24.4211 29.8297 24.8192L22.5735 29.8986C21.9107 30.3625 21 29.8884 21 29.0793V18.9207C21 18.1116 21.9107 17.6375 22.5735 18.1014L29.8297 23.1808Z"
        fill={theme.palette.secondary.main}
      />
    </svg>
  );
};
